const misc = {
  notFound: {
    title: "Page not found",
    message: "The page you are looking for doesn't exist or has been moved.",
    backToHome: "Return Home",
    error404: "404",
  }
};

export default misc; 